import React from 'react';
import './styles.scss';

const _ExecResultPropContainer: React.FC<{ children?: React.ReactNode }> = (props) => {
  return <div className='exec-result-prop-container'>{props.children}</div>;
};
export const ExecResultPropContainer = React.memo(_ExecResultPropContainer);
